import {module as m} from 'modujs';
import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import {StoreSingleton} from "../../singletons/store";
import gsap from "gsap";

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.swiper = null;
    }

    /**
     * INIT
     */
    init() {
        if(StoreSingleton.isMobile) {
            this.swiper = new Swiper(this.el, {
                slidesPerView: 1,
                autoHeight: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                modules: [Pagination],
            });

            this.swiper.on('slideChange', (e) => {
                console.log('changePath', this.swiper.slides[this.swiper.activeIndex].dataset.animation, 'Lottie', this.swiper.slides[this.swiper.activeIndex].dataset.domid);
                this.call('changePath', this.swiper.slides[this.swiper.activeIndex].dataset.animation, 'Lottie', this.swiper.slides[this.swiper.activeIndex].dataset.domid);
            });
        }
    }
}
